<!-- src/components/HomePage.vue -->
<template>
  <div class="home-page">
    <!-- 固定顶栏 -->
    <header class="top-bar">
      <button @click="$router.push('/search')" class="btn">🔍 搜索</button>
      <span class="title">饕饕记</span>
      <button @click="$router.push('/history')" class="btn">👀 看过</button>
    </header>

    <!-- 固定标签栏 -->
    <nav class="tabs">
      <div
        v-for="(tab, idx) in tabs"
        :key="tab"
        :class="['tab-item', { active: idx === activeTab }]"
        @click="onTabClick(idx)"
      >
        {{ tab }}
      </div>
    </nav>

    <!-- 横向面板容器 -->
    <div
      class="panels"
      ref="panels"
      @scroll="onScroll"
    >
      <div
        class="panel"
        v-for="(tab, idx) in tabs"
        :key="tab"
      >
        <HomeContent v-if="idx === 0" />
        <CategoryPage v-else :key="tab" :category="tab" />
      </div>
    </div>
  </div>
</template>

<script>
import HomeContent from './HomeContent.vue';
import CategoryPage from './CategoryPage.vue';

export default {
  name: 'HomePage',
  components: { HomeContent, CategoryPage },
  data() {
    return {
      tabs: ['推荐', '电影', '电视剧', '综艺', '动漫', '短剧'],
      activeTab: 0,
      panelWidth: 0
    };
  },
  methods: {
    onTabClick(idx) {
      this.activeTab = idx;
      // 平滑滚动到对应面板
      this.$refs.panels.scrollTo({
        left: this.panelWidth * idx,
        behavior: 'smooth'
      });
    },
    onScroll() {
      const scrollLeft = this.$refs.panels.scrollLeft;
      const idx = Math.round(scrollLeft / this.panelWidth);
      if (idx !== this.activeTab) {
        this.activeTab = idx;
      }
    },
    updatePanelWidth() {
      // 每个面板实际宽度等于容器可见宽度
      this.panelWidth = this.$refs.panels.clientWidth;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.updatePanelWidth();
      window.addEventListener('resize', this.updatePanelWidth);
    });
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updatePanelWidth);
  }
};
</script>

<style scoped>
.home-page {
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
}

/* 顶栏 */
.top-bar {
  position: fixed;
  top: 0; left: 0; right: 0;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,0,0,0.1);
  z-index: 100;
}
.btn {
  background: none; border: none; font-size: 18px;
}
.title {
  font-size: 18px; font-weight: bold;
}

/* 标签栏 */
.tabs {
  position: fixed;
  top: 44px; left: 0; right: 0;
  height: 44px;
  display: flex;
  align-items: center;
  overflow-x: auto;
  background: #fafafa;
  z-index: 99;
}
/* 隐藏滚动条 */
.tabs::-webkit-scrollbar { display: none; }
.tabs { -ms-overflow-style: none; scrollbar-width: none; }
.tab-item {
  flex-shrink: 0;
  padding: 10px 16px;
  cursor: pointer;
  color: #444;
}
.tab-item.active {
  color: #1890ff;
  border-bottom: 2px solid #1890ff;
}

/* 面板容器 */
.panels {
  position: absolute;
  top: 88px; /* 44px 顶栏 + 44px 标签栏 */
  bottom: 0; left: 0; right: 0;
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: none;
}
/* 隐藏横向滚动条 */
.panels::-webkit-scrollbar { display: none; }
.panels { -ms-overflow-style: none; scrollbar-width: none; }

/* 每个面板 */
.panel {
  flex: 0 0 100%;
  scroll-snap-align: start;
  overflow-y: auto;
}

/* 给面板内容加内边距，避免被固定头部遮挡 */
.panel > * {
  padding: 12px;
}
</style>